import { useAuthStore } from "~/store/auth/auth.store";
import { RolesEnums } from "~/utils/enums/roles.enums";
import { forbiddenError, isRouteForbidden } from "~/utils/route-access";

export default defineNuxtRouteMiddleware(({ meta }) => {
  /**
   * Named middleware: blocks a route when the user lacks the required role(s) or
   * holds an excluded one (see isRouteForbidden). Admins are whitelisted. A
   * blocked access shows the error page (403) rather than silently aborting, so a
   * user whose rights were downgraded onto a page they can no longer access lands
   * on a clear "Accès non autorisé" screen.
   */

  const authStore = useAuthStore();

  const requiredRoles = meta.roles as RolesEnums[] | undefined;
  const excludeRoles = meta.excludeRoles as RolesEnums[] | undefined;

  if (isRouteForbidden(requiredRoles, excludeRoles, authStore.getRoles)) {
    return showError(forbiddenError());
  }
});
